import { ActionResult } from '../enums';
import type { ActionHandler } from '../types';

type RefreshComponent = {};

type RefreshComponentContext = {
  feedEntry?: {
    _parentFeedPath: string;
  };
};

/**
 * Requests a UI component refresh for the current feed entry.
 *
 * @param action - Prepared action with `context.feedEntry`.
 * @param ctx - Action runtime context (unused here).
 * @returns `ActionResult.Success` when dispatched; `ActionResult.Error` on missing context.
 */
export const refreshComponent: ActionHandler<
  RefreshComponent,
  RefreshComponentContext
> = async (action) => {
  if (!action.context) {
    return ActionResult.Error;
  }

  if (!action.context.feedEntry) {
    return ActionResult.Error;
  }

  //emit event 'action:refreshComponent'
  window.dispatchEvent(
    new CustomEvent('action:refreshComponent', {
      detail: {
        feedPath: action.context.feedEntry._parentFeedPath,
      },
    })
  );

  return ActionResult.Success;
};
